import { TabContext, TabList, TabPanel } from '@mui/lab';
import { FunctionComponent, useState } from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemProps,
    Stack,
    styled,
    Tab,
    Typography,
} from '@mui/material';

export const BookingChannelTabs = () => {
    const [tabValue, setTabValue] = useState('keycard');

    const handleTabChange = (_event, newValue: string) => {
        setTabValue(newValue);
    };

    return (
        <TabContext value={tabValue}>
            <Stack spacing={3}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange}>
                        <Tab label='Keycard' value='keycard' />
                        <Tab label='e-Ticket' value='e-ticket' />
                        <Tab label='Pick-Up-Voucher' value='pick-up' />
                        <Tab
                            label='Produktion & Versandt durch Bergbahn'
                            value='production'
                        />
                    </TabList>
                </Box>

                <TabPanel
                    sx={{
                        width: '50%',
                    }}
                    value='keycard'
                >
                    <Typography>
                        Ticketbuchung auf eine starjack Keycard oder manuell
                        registrierte Keycard* (*nur bei SKIDATAZutrittssystemen
                        möglich). Vom Gast neu bestellte Keycards werden
                        automatisch von starjack erstellt und versandt. Beim
                        Erstzutritt wird die Berechtigung auf die Karte geladen.
                    </Typography>
                </TabPanel>
                <TabPanel
                    sx={{
                        width: '50%',
                    }}
                    value='e-ticket'
                >
                    <Typography sx={{ fontWeight: 500 }} gutterBottom>
                        Für Zutrittsgates mit QR-Code oder Barcode-Reader
                    </Typography>

                    <Typography>
                        Aktivieren Sie die Option nur, wenn Ihre Zutrittsgates
                        mit QR-Code Reader oder Barcode-Reader ausgestattet
                        sind. Ein e-Ticket befähigt den Gast zum direkten
                        Zugang. Der Gast erhält die Zugangscodes per E-Mail,
                        inkl. Download als PDF-Ticket*. Keine Keycard zur
                        Buchung notwendig. *Das PDF kann mit Ihren Informationen
                        und Grafiken individuell gestaltet werden.
                    </Typography>
                </TabPanel>
                <TabPanel
                    sx={{
                        width: '50%',
                    }}
                    value='pick-up'
                >
                    <Typography sx={{ fontWeight: 500 }} gutterBottom>
                        Ticketabholung am Automaten oder Kassa
                    </Typography>

                    <Typography>
                        Gast erhält per E-Mail einen QR-Code zur Ticketabholung
                        an Ihrer Kassa oder, falls vorhanden, am
                        SKIDATA-Automaten. Voucher kann vom Gast als PDF*
                        heruntergeladen werden. Pfandgebühren können Sie
                        optional bei starjack hinterlegen, diese werden dem Gast
                        bei der Buchung direkt abgerechnet.
                    </Typography>

                    <List
                        sx={{
                            ml: 4,
                            listStyle: 'disc',
                        }}
                        component='ul'
                    >
                        <Li>
                            Ihre Kassa muss mit der SKIDATA ´print & send`
                            Software ausgestattet sein. Optional können
                            Handscanner für das schnellere Lesen des Codes und
                            Ausstellen der Tickets an der Kassa gekoppelt
                            werden. Zutrittstickets müssen von Ihrem
                            Kassapersonal bei Aktivierung dieser Option
                            ausgestellt werden können.
                        </Li>

                        <Li>
                            Ihre Kassa muss mit der SKIDATA ´print & send`
                            Software ausgestattet sein. Optional können
                            Handscanner für das schnellere Lesen des Codes und
                            Ausstellen der Tickets an der Kassa gekoppelt
                            werden. Zutrittstickets müssen von Ihrem
                            Kassapersonal bei Aktivierung dieser Option
                            ausgestellt werden können.
                        </Li>
                    </List>
                </TabPanel>
                <TabPanel
                    sx={{
                        width: '50%',
                    }}
                    value='production'
                >
                    Vom Gast neu bestellte Keycards werden von Ihrem Unternehmen
                    erstellt und an den Gast versendet. Pfand- und
                    Versandgebühren können Sie optional bei starjack
                    hinterlegen, diese werden dem Gast bei der Buchung direkt
                    abgerechnet
                    <List
                        sx={{
                            ml: 4,
                        }}
                        component='ul'
                    >
                        <Li>
                            Die Buchungen gehen in Ihrem SKIDATA System als
                            Reservierung ein. Sie benötigen eine SKIDATA
                            „APS-Kasse“, um diese verarbeiten zu können.
                        </Li>
                    </List>
                </TabPanel>
            </Stack>
        </TabContext>
    );
};

const ListItemWrapper: FunctionComponent<ListItemProps> = (props) => (
    <ListItem {...props} component={'li'} />
);

const Li = styled(ListItemWrapper)(({ theme }) => ({
    display: 'list-item',
    listStyle: 'disc',
    paddingLeft: theme.spacing(1),
}));
